var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5557cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4973,
    stopColor: "#d52b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed56c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 45.2497,
    x2: 469.2544,
    xlinkHref: "#a",
    y1: 45.2495,
    y2: 469.2542
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 170.9987,
    x2: 595.0034,
    xlinkHref: "#a",
    y1: -80.9982,
    y2: 343.0065
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0004,
    x2: 469.0051,
    xlinkHref: "#a",
    y1: 45.0001,
    y2: 469.0049
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130 50h252c44 0 80 36 80 80v252c0 44-36 80-80 80h-252c-44 0-80-36-80-80v-252c0-44 36-80 80-80zm252-40h-252c-66 0-120 54-120 120v252c0 66 54 120 120 120h252c66 0 120-54 120-120v-252c0-66-53.996094-120-120-120zm0 0",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 50h-252c-44 0-80 36-80 80v252c0 44 36 80 80 80h252c44 0 80-36 80-80v-252c0-44-36-80-80-80zm0 50.003906c16.566406 0 30 13.429688 30 30 0 16.566406-13.433594 30-30 30-16.570312 0-30-13.433594-30-30 0-16.570312 13.429688-30 30-30zm-126 55.996094c55.226562 0 100 44.769531 100 100 0 55.226562-44.773438 100-100 100s-100-44.773438-100-100 44.773438-100 100-100zm0 0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412 130.003906c0 16.566406-13.433594 30-30 30-16.570312 0-30-13.433594-30-30 0-16.570312 13.429688-30 30-30 16.566406 0 30 13.429688 30 30zm0 0",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356 256c0-55.226562-44.773438-100-100-100s-100 44.769531-100 100c0 55.226562 44.773438 100 100 100 55.230469 0 100-44.773438 100-100zm-100-60c33.136719 0 60 26.863281 60 60s-26.863281 60-60 60-60-26.863281-60-60 26.863281-60 60-60zm0 0",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 256c0 33.136719-26.863281 60-60 60s-60-26.863281-60-60 26.863281-60 60-60 60 26.863281 60 60zm0 0",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m382 0h-146c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h146c60.652344 0 110 49.34375 110 110v252c0 60.65625-49.347656 110-110 110h-252c-60.652344 0-110-49.34375-110-110v-252c0-60.65625 49.347656-110 110-110h26c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-26c-71.683594 0-130 58.316406-130 130v252c0 71.683594 58.316406 130 130 130h252c71.683594 0 130-58.316406 130-130v-252c0-71.683594-58.316406-130-130-130zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m356 472h26c49.625 0 90-40.375 90-90v-252c0-49.625-40.375-90-90-90h-252c-49.625 0-90 40.375-90 90v252c0 49.625 40.375 90 90 90h146c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-146c-38.597656 0-70-31.402344-70-70v-252c0-38.597656 31.402344-70 70-70h252c38.597656 0 70 31.402344 70 70v252c0 38.597656-31.402344 70-70 70h-26c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m366 256c0-60.652344-49.347656-110-110-110s-110 49.347656-110 110 49.347656 110 110 110 110-49.347656 110-110zm-110 90c-49.625 0-90-40.375-90-90s40.375-90 90-90 90 40.375 90 90-40.375 90-90 90zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 186c-38.597656 0-70 31.402344-70 70s31.402344 70 70 70 70-31.402344 70-70-31.402344-70-70-70zm0 120c-27.570312 0-50-22.429688-50-50s22.429688-50 50-50 50 22.429688 50 50-22.429688 50-50 50zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m422 130.003906c0-22.058594-17.945312-40-40-40-22.058594 0-40 17.941406-40 40 0 22.054688 17.941406 40 40 40 22.054688 0 40-17.945312 40-40zm-60 0c0-11.03125 8.972656-20 20-20s20 8.96875 20 20c0 11.027344-8.972656 20-20 20s-20-8.972656-20-20zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m196.003906 20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-.007812c-5.519532 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m315.996094 452c-5.523438 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.b5001401e182f7132ae6094670d4c035.svg";
export { ForwardRef as ReactComponent };